import React, { useEffect, useState } from "react";
import './Header.css';
import { AppBar, Box, Toolbar, IconButton, Typography, Menu, MenuItem, ListItemIcon, ListItemText, Tooltip } from "@mui/material";
import { Link } from "react-router-dom";
import MenuIcon from "@mui/icons-material/Menu";
import HomeIcon from "@mui/icons-material/Home";
import LoginIcon from '@mui/icons-material/Login';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import MeetingRoomIcon from '@mui/icons-material/MeetingRoom';
import { UsuarioEstaLogado, UsuarioLogadoGet, UsuarioLogout } from "../../utils/usuarioEstaLogado";
import TokenServiceExpired from "../token/TokenServiceExpired";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../app/store";
import { toggleSliceMenuLateral } from "./headerSlicer";
import ThemeSwitcher from "./ThemeSwitcher";
import { useNavigate } from "react-router-dom";
import configUrls from "../../config/configUrls";
import { config } from "process";
import { HeaderUserMenu } from "./HeaderUserMenu";


// Componente MenuItem reutilizável
const MenuItemLink = ({ to, children, onClick }: { to: string, children: React.ReactNode, onClick?: () => void }) => (
  <MenuItem component={Link} to={to} onClick={onClick}>
    <ListItemText primary={children} />
  </MenuItem>
);

export function Header() {

  const navigate = useNavigate();

  const [menuAnchor, setMenuAnchor] = useState<null | HTMLElement>(null);
  const [menuSairAnchor, setMenuSairAnchor] = useState<null | HTMLElement>(null);

  const usuarioLogado = UsuarioEstaLogado();
  const token = UsuarioLogadoGet();

  const [theme, setTheme] = useState<string>('saga-blue');



  //pegar o redux
  const dispatch = useDispatch();
  const headerButtons = useSelector((state: RootState) => state.header);

  const handleClickMenuLateral = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    const prevProcessoSelecionado = headerButtons.menuProcessoSelecionado;
    //se tiver processo selecionado eu redireciona para a pagina inicial, senao apenas esncondo o menu
    dispatch(toggleSliceMenuLateral());

    if (prevProcessoSelecionado) {
      navigate(configUrls.PROCESSO_LIST_RT);
    }
  }

  // Função para atualizar o tema
  const handleThemeChange = (newTheme: string) => {
    setTheme(newTheme);
    // Aqui você pode adicionar lógica adicional, como aplicar o tema no seu CSS ou em uma biblioteca de temas.
   
  };
  useEffect(() => {
    document.body.className = theme; // Modifica a classe do corpo com base no tema
  }, [theme]);

  // Função central para fechar todos os menus
  const handleCloseAllMenus = () => {
    setMenuAnchor(null);
    setMenuSairAnchor(null);
  };

  const handleMenuOpen = (event: React.MouseEvent<HTMLElement>, setAnchor: React.Dispatch<React.SetStateAction<null | HTMLElement>>) => setAnchor(event.currentTarget);

  const handleLogout = (event: React.MouseEvent<HTMLElement>) => {
    event.preventDefault();
    UsuarioLogout();
    window.location.href = configUrls.SABER_LOGIN;
  };






  return (
    <>



      <Box
        className="full-width-box"

      >
       
        


        <AppBar position="static">
          <Toolbar>
            <IconButton
              size="large"
              edge="start"
              color="inherit"
              onClick={handleClickMenuLateral}
              sx={{ mr: 2 }}>
              <MenuIcon />
            </IconButton>





            {/* Menu de Usuário (se estiver logado) */}
            <Typography variant="h6" component="div" flexGrow={1}>


            </Typography>




            <>
            <HeaderUserMenu sistema="saber"/>
            </>




          </Toolbar>
        </AppBar>
      </Box>
    </>
  );
}
